import { type Theme } from '@mui/material/styles';

import { type MuiThemeCallbackOrValue, type MuiThemeCallbackValue } from '../../types/mui/sx';

/**
 * Evaluates a prop who's value can be defined as either a callback, {@link MuiThemeCallback<T>},
 * or the value directly, {@link T}.
 */
export const evaluateMuiThemeCallbackOrValue = <T extends MuiThemeCallbackValue>(
  value: MuiThemeCallbackOrValue<T>,
  theme: Theme,
): T => (typeof value === 'function' ? value(theme) : value);
